<template>
  <z-card-modal
    data-cy="edit-guest-data-modal"
    closable
    :title="$t('alerts.edit_guest_data_title')"
    :opened="isOpened"
    @change="$emit('close')"
  >
    <template #content>
      <div class="has-children-content">
        <div class="body-text">
          {{ $t("alerts.edit_guest_data_description") }}
        </div>

        <div class="buttons">
          <z-btn
            data-cy="understand-btn"
            class="understand-btn"
            secondary
            :text="$t('alerts.edit_data')"
            @click="handleButtonClick('edit')"
          />

          <z-btn
            data-cy="understand-btn"
            class="understand-btn"
            secondary
            :text="$t('alerts.create_data')"
            @click="handleButtonClick('create')"
          />
        </div>
      </div>
    </template>
  </z-card-modal>
</template>

<script>
export default {
  props: {
    isOpened: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleButtonClick = (type) => {
      emit("close")

      emit("enable-edit", {
        canEdit: true,
        actionType: type,
      })
    }

    return {
      handleButtonClick,
    }
  },
}
</script>

<style lang="scss" scoped>
.has-children-content {
  display: grid;
  row-gap: 15px;
  margin-top: 20px;
}

@media screen and (min-width: 786px) {
  .buttons {
    display: flex;
    justify-content: center;
    // coloca um space betweeen nos botoes
    column-gap: 10px;
  }
  .understand-btn {
    width: auto;
  }
}
</style>
